import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";
import { API_BASE_URL } from "../../config/api.js";

export const overviewService = {
    getOverviewData: async () => {
        try {
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.GET_OVERVIEW,
                method: "GET",
                accessToken: localStorage.getItem("accessToken"),
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching overview data:", error);
            throw error;
        }
    },
    downloadTenantDemographicsReport: async () => {
        try {
            const token = localStorage.getItem("accessToken");
            const res = await fetch(`${API_BASE_URL}/AdminDashBoard/downloadTenantDemographicsReport`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            if (!res.ok) throw new Error(`Download failed: ${res.status}`);
            return await res.blob();
        } catch (error) {
            console.error("Error downloading tenant demographics report:", error);
            throw error;
        }
    }
};
